import './App.css';
import React, { Component, useCallback, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import { BrowserRouter, Link } from 'react-router-dom';
import RouterFunction from './router/routes.js';
import icon1 from './assets/Buy ticket-white-02.png'
import icon2 from './assets/Calendar-01-white-02.png'
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { api_url } from './config.js';
import axios from 'axios';



    

function App() {

    const [menudata, setData] = useState([]);
  const getMenuData = async (url) => {
        const res = await axios.get(url + 'menu');
        setData(res?.data?.menu?.menus);
    }
  useEffect(() => {
          getMenuData(api_url);
      }, [])

      const showBuyTicket = menudata.some(
    (item) =>
        item.title_eng === "Buy Ticket" &&
        item.is_disabled == 0
);
  return (
    <>
    <div className='classForMargin'></div>
        <RouterFunction />

      <section className="buy_now_section">
        <div className="row m-0">

    {showBuyTicket && (
        <div className="col-6">
            <a href="https://tickets.third-space.in/DTSCustomerWeb/home">
                <img
                    src={icon1}
                    style={{ height: "20px" }}
                    alt=""
                />
                Buy ticket
            </a>
        </div>
    )}

    <div className={showBuyTicket ? "col-6 text-center" : "col-12 text-center"}>
        <img
            style={{ height: "25px" }}
            src={icon2}
            alt=""
        />
        What's on
    </div>

</div>
      </section>
    </>
  );
}

export default App;
